<header class="fixed-top font-titulos">
  <div class="w-100 header-top" (click)="ocultarMenu()">
    <div class="container display-flex">
      <logo (click)="ocultarMenu()" class="img-logo-top-principal"
        *ngIf="configuracion?.seccionInformacion == 'contenido'">
        <span>
          <a class="logo navbar-brand" href="#/portal">
            <img alt="AIQ" *ngIf="configuracion?.logoCabecera"
              [src]="'data:image/jpg;base64,'+configuracion?.logoCabecera">
          </a>
        </span>
      </logo>
      <ul class="navbar-nav top-nabvar ml-auto">
        <li class="nav-item centrar-vertical" routerLink="/portal" mdbWavesEffect>
          <a class="nav-link link-landing txt-primary"><i title="Inicio" class="fa fa-home"></i></a>
        </li>
        <!--Inicio de seccion de notificaciones-->
        <li class="nav-item dropdown centrar-vertical ml-3" dropdown #dropdown='bs-dropdown' *ngIf="user">
          <a dropdownToggle mdbWavesEffect type="button" class="nav-link">
            <i title="Notificaciones" class="fas fa-bell txt-primary"></i><span class="caret"></span>
          </a>
          <span class="counter-notifications" *ngIf="notifications?.length > 0">{{notifications?.length}}</span>
          <ul *dropdownMenu class="dropdown-menu dropdown dropdown-primary" role="menu"
            style="left: -6rem; width: 300px !important;">
            <perfect-scrollbar style="max-height: 255px">
              <ul class="list-group">
                <li class="list-group-item text-muted px-2 py-1 cursor-pointer"
                  *ngFor="let notification of notifications"
                  (click)="dropdown.show(); seenNotification(notification, true);">
                  <small class="float-right"><strong>{{notification?.fecha_creacion?.$date | date: 'dd/MM/yyyy hh:mm a'
                      }}</strong>
                  </small>
                  <div class="clearfix"></div>
                  <small>{{notification.detalle}}</small>
                </li>
                <li class="list-group-item text-muted text-center" *ngIf="notifications?.length == 0">
                  <small>Sin notificaciones por el momento</small>
                </li>
              </ul>
            </perfect-scrollbar>
            <li>
              <a href="javascript: void(0)" mti-color-hover-item class="dropdown-item waves-light text-center"
                mdbWavesEffect (click)="notificationsModal.modal.show()">
                Ver todas las notificaciones
              </a>
            </li>

          </ul>
        </li>
        <!--Fin de seccion de notificaciones-->

        <li class="nav-item centrar-vertical ml-3" mdbWavesEffect>
          <input type="text" class="form-control hd-item-busqueda my-icon content-busqueda" placeholder="Búsqueda..."
            (keyup)="loadTramites()" (focus)="showList()" (click)="loadCategorias()" (blur)="hideList()"
            [(ngModel)]="searchStr.s">
        </li>
        <!-- Resultados de la búsqueda -->
        <div *ngIf="showBusqueda"
          class="list-group position-absolute dropdown col-12 col-lg-12 shadow p-0 panel-busqueda">
          <div *ngFor="let form of resultadoBusqueda">
            <a href="javascript: void(0)"
              class="list-group-item d-flex align-items-center waves-light text-muted flipInX fast-4"
              *ngIf="form.categorias_id" (click)="detalle(form._id)" mdbWavesEffect>
              {{ form.nombre }}
            </a>
            <a href="javascript: void(0)"
              class="list-group-item d-flex align-items-center waves-light text-muted flipInX fast-4"
              *ngIf="form._id && !form.categorias_id" (click)="click('detail', form._id, $event)" mdbWavesEffect>
              <mdb-icon fas icon="angle-right"></mdb-icon>
              <span class="font-weight-bold">&nbsp;{{ form.nombre }}</span>
            </a>
          </div>
          <a href="javascript: void(0)" class="list-group-item waves-light text-center text-muted flipInX fast-4"
            *ngIf="resultadoBusqueda.length < 1" mdbWavesEffect>
            {{ mensajeNoBusqueda }}
          </a>
        </div>
        <li class="nav-item centrar-vertical ml-2 dropdown" *ngIf="user" dropdown>
          <a dropdownToggle type="button" class="nav-link dropdown-toggle btn-header-user txt-primary">
            <i title="Cerrar sesión" class="fa fa-user"></i><span class="caret"></span></a>
          <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary dropdown-user" role="menu">
            <a class="dropdown-item top-nav" href="javascript: void(0)" routerLink="/portal//bandeja_entrada">Mis
              trámites</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item top-nav" href="javascript: void(0)" (click)="formDataUser.modal.show()">Mis
              datos</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item top-nav" href="javascript: void(0)" (click)="logout()">Cerrar sesión</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <mdb-navbar #navbarLP SideClass="navbar navbar-expand-lg navbar-light navbar-landing" [containerInside]="true">
    <logo (click)="ocultarMenu()" class="med-logo logo-two-bg">
      <span>
        <a class="navbar-brand w-100" href="#/portal">
          <img alt="logo" class="img-responsive img-logo" *ngIf="configuracion?.logoCabecera"
            [src]="'data:image/jpg;base64,'+configuracion?.logoCabecera">
        </a>
      </span>
    </logo>
    <logo class="med-logo logo-not-movil"></logo>
    <links>
      <ul class="navbar-nav" style="max-height: 150px;overflow-y: auto;">
        <li class="nav-item dropdown mega-dropdown" *ngIf="menu.length < 1">&nbsp;</li>
        <li class="nav-item dropdown mega-dropdown" *ngFor="let seccion of menu;let indexSeccion = index;" mdbDropdown
          data-toggle="collapse" style="margin-top:-3px;" data-target=".navbar-collapse.show">
          <a mdbDropdownToggle class="nav-link link-cat" style="width: max-content;" aria-haspopup="true"
            (click)="remStyle($event);" (click)="verMenu($event, indexSeccion)"
            [ngStyle]="seccion.active?{fontColor: '#292929'}:''" aria-expanded="false">
            {{ seccion.nombre }}
          </a>
          <div class="dropdown-menu mega-menu menu-mega-head z-depth-1 menu-mega-sm p-0" (mouseleave)="ocultarMenu();"
            (click)="checkDropdownMM($event)">
            <div class="container-fluid bg-mega-menu">
              <div class="row">
                <div
                  class="col-12 col-lg-3 col-md-3 pt-3 pb-3 pl-4 pr-0 color-mega-menu overflow-y-auto overflow-x-hidden sidebar-mega-menu">
                  <ng-container *ngFor="let tipoCategoria of seccion.tiposCategoria; let indexTC = index">
                    <div class="w-100 h6" [ngStyle]="indexTC>0?{marginTop: '2rem', marginBottom: '0'}:''">
                      {{ tipoCategoria.nombre }}
                    </div>
                    <ul class="list-unstyled lista-categorias-mega-menu">
                      <ng-container *ngFor="let categoria of tipoCategoria.categorias; let indexCategoria = index;">
                        <li *ngIf="categoria.estatus"
                          (click)="verTramites(indexSeccion, categoria._id, categoria.nombre, false)"
                          class="link item-categoria-mega-menu display-flex pt-1 pb-1" style="font-size: 14px;"
                          [ngClass]="categoria.active==true ? 'item-categoria-mega-menu-active' : 'item-categoria-mega-menu-inactive'">
                          <div style="margin: 0 5px;">
                            <img [src]="'data:image/jpg;base64,'+categoria.archivo" alt="Categoria" width="15px"
                              height="15px" *ngIf="categoria.archivo !='' && categoria.archivo">
                            <i class="fa fa-folder mr-1" *ngIf="categoria.archivo =='' || !categoria.archivo"></i>
                          </div>
                          <div style="margin:0;">{{ categoria.nombre }}</div>
                        </li>
                      </ng-container>
                    </ul>
                  </ng-container>
                </div>
                <div class="col-12 col-lg-9 col-md-9 pt-2 pb-2 bg-white content-mega-menu">
                  <div class="w-100 h5 principal-texto display-flex">
                    Trámites
                  </div>
                  <hr>
                  <section class="container-fluid mr-0 p-0">
                    <div class="row">
                      <div class="col-12" style="height: auto;max-height: 180px;">
                        <div style="color:black !important;">
                          {{ tramitesMM[indexSeccion] }}
                        </div>
                        <mdb-carousel #carouselMegaMenu *ngIf="tramitesMM[indexSeccion]?.sliders?.length>0"
                          [isControls]="true"
                          class="carousel-multi-item multi-animation testimonial-carousel carousel-content-mega-menu"
                          [type]="'carousel-multi-item'" [animation]="'slide'" [interval]="0">
                          <mdb-slide style="height: auto; line-height: 15px;"
                            *ngFor="let slider of tramitesMM[indexSeccion]?.sliders">
                            <div class="row">
                              <ng-container *ngIf="slider?.tramites?.length>0">
                                <div class="col-12 col-sm-6 col-md-6 col-lg-6 principal-texto"
                                  style="word-wrap: break-word;" [ngClass]="(indexTramite>1)?'mt-2':''"
                                  *ngFor="let tramite of slider?.tramites; let indexTramite = index;">
                                  <mdb-card class="tarjetas-dc-animacion link card-tramite" style="margin: 2px;"
                                    (click)="detalleTramite(tramite._id); hideNav(navbarLP);">
                                    <mdb-card-body style="padding: 15px !important; height: 130px;">
                                      <mdb-card-text class="text-center">
                                        <div class="d-flex" style="height: 100px;overflow-y: auto;">
                                          <h6 class="m-auto">{{ tramite.nombre }}</h6>
                                        </div>
                                      </mdb-card-text>
                                    </mdb-card-body>
                                  </mdb-card>
                                </div>
                              </ng-container>
                            </div>
                            <ng-container *ngIf="slider?.tramites?.length<1">
                              {{ sinTramites }}
                            </ng-container>
                          </mdb-slide>
                        </mdb-carousel>
                        <p class="principal-texto" *ngIf="tramitesMM[indexSeccion]?.sliders?.length<1">
                          {{ sinTramites }}
                        </p>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </links>
  </mdb-navbar>
</header>

<app-login-citizen #formLogin (user)="setUserSession($event)"></app-login-citizen>
<app-data-user #formDataUser></app-data-user>
<app-notifications-modal #notificationsModal></app-notifications-modal>

<div mdbModal #infoModal="mdb-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-notify modal-info modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right text-white" aria-label="Close" (click)="infoModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100 text-center text-white" id="myModalLabel">AVISO IMPORTANTE</h4>
      </div>
      <div class="modal-body text-justify">
        <p>Por medio del presente, se hace del conocimiento que el día 1° (primero) de
          noviembre de 2018, se comunica que únicamente podrán ser capturados e
          ingresados los trámites referentes al pago de impuestos inmobiliarios, de manera
          electrónica a través del Portal en Línea del Municipio de Corregidora, cuya liga es la
          siguiente: https://www.corregidoraenlinea.gob.mx/</p>
        <p>Por lo que refiere al día 02 (dos) de noviembre de 2018, se informa que será
          considerado como día inhábil.</p>
        <p>Lo anterior, para tomar las medidas correspondientes y evitar así, cualquier molestia
          que pueda ocasionarse derivado de los plazos y trámites ingresados ante esta
          Autoridad Fiscal.</p>
        <p class="text-center">Dirección de Ingresos <br>
          Secretaría de Tesorería y Finanzas</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary waves-effect m-auto" mdbWavesEffect
          (click)="infoModal.hide()">Aceptar
        </button>
      </div>
    </div>
  </div>
</div>